<template>
  <div id="header" :style="'margin-bottom:'+marginBottom">
    <router-link to="/">
      <img id="logo-img" src="../assets/logo.png" alt="logo"/>
    </router-link>
    <div id="header_nav">
      <router-link to="/">
        <h3 class="header_nav_button">Accueil</h3>
      </router-link>
      <router-link to="/entrainement">
        <h3 class="header_nav_button">S'entrainer</h3>
      </router-link>
      <router-link to="/contact">
        <h3 class="header_nav_button">Nous contacter</h3>
      </router-link>
      <router-link to="/app">
        <h3 class="header_nav_button">Télécharger l'application</h3>
      </router-link>
    </div>
    <div id="hamburger_button" @click="open_close_menu()">
      <span class="hamburger_part"></span>
      <span class="hamburger_part"></span>
      <span class="hamburger_part"></span>
    </div>
    <div id="hamburger_list" class="hamburger_list_open hamburger_list_close">
      <router-link to="/" @click.native="open_close_menu()">
        <h3 class="header_nav_button">Accueil</h3>
      </router-link>
      <router-link to="/entrainement" @click.native="open_close_menu()">
        <h3 class="header_nav_button">S'entrainer</h3>
      </router-link>
      <router-link to="/contact" @click.native="open_close_menu()">
        <h3 class="header_nav_button">Nous contacter</h3>
      </router-link>
      <router-link to="/app" @click.native="open_close_menu()">
        <h3 class="header_nav_button">Télécharger l'application</h3>
      </router-link>
    </div>
  </div>
</template>


<style scoped>
  #logo-img {
    width: 100px;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
  a {
    text-decoration: none;
  }
  h1 {
    margin-bottom: unset;
  }
  #header {
    z-index: 999;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;

    height: 80px;
    padding: 0 4%;
    flex-shrink: 0;

    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    background-color: var(--color-cards);
    transition: background var(--transition-duration-color),
      height .5s;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #header_nav {
    display: flex;
  }
  .header_nav_button {
    color: var(--color-text-2);
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: .3s;
    position: relative;
    margin-right: 40px;
  }
  #header_nav a:last-child > .header_nav_button {
    margin-right: unset;
  }

  #hamburger_button {
    cursor: pointer;
    transform: scale(.8);
  }


  #hamburger_list {
    position: absolute;
    left: 0;
    right: 0;
    top: 60px;
    background-color: var(--color-cards);
    box-shadow: inset 0 3px 3px rgba(0, 0, 0, 0.12), 0 3px 6px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    transition: .3s;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .hamburger_list_open {
    height: 160px;
  }
  .hamburger_list_close {
    height: 0;
    box-shadow: none;
  }


  .hamburger_part {
    display: block;
    height: 3px;
    width: 30px;
    border-radius: 4px;
    background-color: var(--color-text-2);
    transition: .2s;
  }
  .hamburger_part:nth-child(2) {
    margin: 6px 0;
  }
  .hamburger_button_open .hamburger_part:nth-child(1) {
    transform-origin: 2px 2px;
    transform: rotate(45deg);
  }
  .hamburger_button_open .hamburger_part:nth-child(2) {
    opacity: 0;
    transform: scale(0.2);
  }
  .hamburger_button_open .hamburger_part:nth-child(3) {
    transform-origin: 2px 2px;
    transform: rotate(-45deg);
  }


  @media screen and (max-width: 840px) {
    #header_title {
      font-size: 26px;
    }
    #header {
      height: 60px;
      margin-bottom: 0;
    }

    #header_nav {
      display: none;
    }

    .header_nav_button {
      width: 100%;
      text-align: center;
      margin: 0;
      padding: 7px 0;
      background-color: var(--color-cards);
      transition: .7s ease-in-out .3s;
    }
    @media (hover: hover) {
      .header_nav_button:hover {
        background-color: var(--color-background);
        transition: .5s ease-in-out;
      }
    }
    #hamburger_list > a:first-of-type > .header_nav_button {
      margin-top: 7px;
    }
    .header_nav_button {
      opacity: 1;
      transition: opacity .4s .1s;
    }
    .hamburger_list_close .header_nav_button {
      opacity: 0;
      transition: opacity .15s;
    }
  }
  @media screen and (min-width: 840px) {
    #hamburger_button {
      display: none;
    }
    #hamburger_list {
      display: none;
    }

    .header_nav_button::after {
      content: "";
      position: absolute;
      top: 22px;
      left: 50%;
      height: 2px;
      background-color: var(--color-main);
      width: 0;
      transition: .4s;
    }
    @media (hover: hover) {
      .header_nav_button:hover::after {
        left: 0;
        width: 100%;
      }
    }
  }

  @media (hover: hover) {
    #header_title:hover {
      opacity: .5;
    }
    .header_nav_button:hover {
      color: var(--color-main);
    }
  }
</style>

<script>
  export default {
    data() {
      return {
        menu_open: false,
        marginBottom: '10px'
      }
    },
    methods: {
      open_close_menu () {
        let menu = document.getElementById('hamburger_list'),
            button = document.getElementById('hamburger_button')

        if (this.menu_open) {
          menu.classList.add('hamburger_list_close')
          button.classList.remove('hamburger_button_open')
        }
        else {
          menu.classList.remove('hamburger_list_close')
          button.classList.add('hamburger_button_open')
        }

        this.menu_open = !this.menu_open
      }
    },
    watch:{
      $route (route){
        this.marginBottom = (route.path.includes('/quiz') || route.path.includes('/test')) ? 0 : '10px'
      }
    }
  }
</script>